import type Component from "./components/Component";

export interface Route {
    path: string;
    label?: string;
    view: () => Component;
}

export default class Router {

    private readonly outlet: HTMLElement;
    private readonly routes: Map<string, Route> = new Map();

    constructor(outlet: HTMLElement, routes: Route[]) {
        this.outlet = outlet;
        for (const route of routes) {
            this.routes.set(route.path, route);
        }

        // Nettlesaren endrar location.hash sjølv når ei #-lenke blir klikka,
        // så vi treng ingen klikk-lyttar — berre dette eventet.
        window.addEventListener("hashchange", () => this.handleRoute());
    }

    /** Teiknar første visning. Må kallast etter at outletet er i dokumentet. */
    public init(): void {
        if (!window.location.hash) {
            window.location.hash = "#/";   // utløyser hashchange
        } else {
            this.handleRoute();
        }
    }

    private handleRoute(): void {
        const path = (window.location.hash || "#/").replace(/^#/, "");
        const route = this.routes.get(path) ?? this.routes.get("/404");

        if (route === undefined) {
            throw new Error(`inga rute for "${path}", og inga /404-rute er registrert`);
        }

        this.outlet.replaceChildren(route.view());
    }
}
